import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters('design', [
            'showBtnStart',
            'menuOffsetLeftTop',
            'menuOffsetMarginLeftTop',

            'buttonPositionSticky',
            'widgetOffset',

            'menuPositionVertical',
            'menuPositionHorizontal',
            'chatPositionHorizontalOffset'
            // ...
        ])
    }
}
